<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let mtc of form?.controls; let i = index">
    <div class="mtc-container-fields">
      <mat-form-field>
        <input
          matInput
          placeholder="Riferimento alla parte (MTCP)"
          formControlName="MTCP">
      </mat-form-field>
      <app-input-vocabulary-autocomplete
        formControlName="MTCM"
        [vocabularyName]="'V_F_MTCM'"
        [placeholder]="'Materia (MTCM)'">
      </app-input-vocabulary-autocomplete>
      <app-input-vocabulary-autocomplete
        formControlName="MTCT"
        [vocabularyName]="'V_F_MTCT'"
        [placeholder]="'Tecnica (MTCT)'">
      </app-input-vocabulary-autocomplete>
      <mat-form-field>
        <input
          matInput
          placeholder="Note (MTCS)"
          formControlName="MTCS">
      </mat-form-field>
      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi materia' | translate }}
  </button>
</div>
